import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@coworker/http-client";
import { INTERVAL } from "../../constants/clientTime";

export const LAST_REFILLED_QUERY_KEY = "locationLastRefilled";
export const useLocationLastRefilled = (
  isRefillLocation: boolean,
  articleNo: string,
  refillLocation: string
) => {
  const canFetch = Boolean(isRefillLocation && articleNo && refillLocation);

  return useQuery({
    queryKey: [LAST_REFILLED_QUERY_KEY, articleNo, refillLocation],
    queryFn: async () => {
      if (!canFetch) {
        return null;
      }
      return await httpClient.tasks.get<{
        lastRefilled: string;
        quantity: number;
      }>("/v1/tasks/task_last_refilled", {
        params: { articleNo, refillLocation },
      });
    },
    enabled: canFetch,
    staleTime: 1 * INTERVAL.MINUTE,
  });
};
